import createIcon from '../../createIcon';

/**
 * @component @name LayersClear
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuODEgMTUuOTU0OEwyMSAxNS4wMzQ4TDE5LjU3IDEzLjYwNDhMMTguMzggMTQuNTI0OEwxOS44MSAxNS45NTQ4Wk0xOS4zNiAxMS4yMzQ4TDIxIDkuOTY0ODRMMTIgMi45NjQ4NEw5LjA5IDUuMjM0ODRMMTYuOTYgMTMuMTE0OEwxOS4zNiAxMS4yMzQ4Wk0zLjI3IDEuOTY0ODRMMiAzLjIzNDg0TDYuMjIgNy40NTQ4NEwzIDkuOTY0ODRMNC42MyAxMS4yMzQ4TDEyIDE2Ljk2NDhMMTQuMSAxNS4zMzQ4TDE1LjUzIDE2Ljc2NDhMMTIgMTkuNTA0OEw0LjYzIDEzLjc3NDhMMyAxNS4wMzQ4TDEyIDIyLjAzNDhMMTYuOTUgMTguMTg0OEwyMC43MyAyMS45NjQ4TDIyIDIwLjY5NDhMMy4yNyAxLjk2NDg0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LayersClear = createIcon('LayersClear', [
  [
    'path',
    {
      d: 'M19.81 15.9548L21 15.0348L19.57 13.6048L18.38 14.5248L19.81 15.9548ZM19.36 11.2348L21 9.96484L12 2.96484L9.09 5.23484L16.96 13.1148L19.36 11.2348ZM3.27 1.96484L2 3.23484L6.22 7.45484L3 9.96484L4.63 11.2348L12 16.9648L14.1 15.3348L15.53 16.7648L12 19.5048L4.63 13.7748L3 15.0348L12 22.0348L16.95 18.1848L20.73 21.9648L22 20.6948L3.27 1.96484Z',
      key: 't54len',
    },
  ],
]);

export default LayersClear;
